var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "goods_nav_auto_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "tips" }, [_vm._v("配置分类")]),
      _vm._l(_vm.value.config.value, function (item, index) {
        return _c(
          "div",
          { key: item.type, staticClass: "box" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                " " + _vm._s(_vm._f("filterType")(item.type, "type")) + " "
              ),
            ]),
            item.type === "2"
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "value." + index + ".title",
                      rules: [
                        {
                          required: true,
                          message: "展示名称不可为空",
                          trigger: "change",
                        },
                        {
                          max: 6,
                          message: "名称长度最多6个字",
                          trigger: "change",
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "title-box" },
                      [
                        _c("div", { staticClass: "label" }, [_vm._v("展示为")]),
                        _c("el-input", {
                          attrs: {
                            placeholder: "输入1-6个字标题",
                            clearable: "",
                          },
                          model: {
                            value: item.title,
                            callback: function ($$v) {
                              _vm.$set(item, "title", $$v)
                            },
                            expression: "item.title",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "value." + index + ".imageurl",
                  rules: [
                    {
                      required: true,
                      message: "图片不可为空",
                      trigger: "change",
                    },
                  ],
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "upload-item-wrap" },
                  [
                    _c("upload-file", {
                      ref: "uploadBanner",
                      refInFor: true,
                      attrs: {
                        "link-url": _vm.linkUrl,
                        tempurl: item.imageurl,
                        canDel: Boolean(item.imageurl),
                        deletePadding: true,
                        uploadInfo: _vm.uploadInfo,
                      },
                      on: {
                        onDelete: function ($event) {
                          return _vm.onDelete(item)
                        },
                        emitUploadFile: function (res) {
                          return _vm.emitUploadFile(res, item)
                        },
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onUpload(index)
                              },
                            },
                          },
                          [_vm._v("上传图片")]
                        ),
                        _vm.pictureInfo[item.type]
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectPicture(item.type, index)
                                  },
                                },
                              },
                              [_vm._v(" 选择图片 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "box-tips" }, [
                  _vm._v(
                    " 建议尺寸为" +
                      _vm._s(_vm._f("filterType")(item.type, "size")) +
                      "，支持JPG、PNG等格式，大小不超过2M "
                  ),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  rules: [{ required: true, message: "菜单不可为空" }],
                  prop: "value." + index + ".link_value",
                },
              },
              [
                _c("el-cascader", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    options:
                      item.type === "2" ? _vm.menuListFilter : _vm.menuList,
                    "collapse-tags": "",
                    props: {
                      label: "show_name",
                      value: "id",
                      children: "childrens",
                      checkStrictly: true,
                      emitPath: false,
                    },
                    clearable: "",
                    filterable: "",
                    placeholder: "选择菜单",
                  },
                  model: {
                    value: item.link_value,
                    callback: function ($$v) {
                      _vm.$set(item, "link_value", $$v)
                    },
                    expression: "item.link_value",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "el-form-item",
        { staticClass: "sort", attrs: { prop: "sort" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("产品展示逻辑")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.sort,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "sort", $$v)
                },
                expression: "value.config.sort",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v(" 按商品列表默认排序（即按商品ID大到小） "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v(" 按商品更新时间倒序展示（更新时间晚到早） "),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio" },
                [
                  _c("el-radio", { attrs: { label: "3" } }, [
                    _vm._v(" 按商品排序值正序展示（即按商品排序值小到大） "),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v("与上方组件的间距")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v("层级高度值")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureIndex: _vm.pictureIndex,
              depot: _vm.depot,
              pictureList: _vm.pictureList,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }